<style lang="less">
    html, body {
        height: 100%; overflow: hidden;
    }
    .app {
        height: 100%; overflow-y: auto; overflow-x: hidden;background-color: #47C878;
    }
    .title{
        height: 0.6rem;
        font-size: 0.31rem;
        color: white;
        margin-top: 0.2rem;
        text-align: center;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
    }
    .backCss{
        height: 0.6rem;
        left: 0.26rem;
        position: absolute;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
    }
    .back{
        height: 0.4rem;
        width:0.4rem;
    }
    .tipsPop{
        background-color: rgba(0,0,0,0.6);
        width: 100%;
        height: 100%;
        position: fixed;
        z-index: 20;
        padding-top: 50%;
        display: flex;
        justify-content: center;
        align-items: start;
    }
    .t_s{
        width: 4rem;
        height: 3rem;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        border-radius: 0.1rem;
        background-color: #fff;
    }
    .t_title{
        width: 1rem;
        height: 1rem;
        margin-top: 0.2rem;
    }
    .t_b{
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-around;
        align-items: center;
        margin:0.2rem auto;
    }
    .t_sure{
        display: inline-block;
        width: 1.2rem;
        line-height: 0.6rem;
        border-radius: 0.1rem;
        background: #47C878;
        color: #fff;
        font-size: 0.24rem;
        text-align: center;
        margin: 0.2rem;
    }
    .t_cancel{
        border: 0.01rem #47C878 solid;
        background-color: white;
        color: #47C878;
    }
    .t_btn{
        display: flex;
        justify-content: space-around;
        align-items: center;
    }
    .title{
       font-size: 0.3rem;
       margin-top: 0.2rem;
       color: #000;
    }
</style>

<template>
    <div class="app scroll" ref="appContainer">
        <section class="tipsPop" v-if="isPayOk">
            <div class="t_s">
                <img class="t_title" src="./assets/images/payStatu.png"/>
                <div class="title">是否完成支付？</div>
                <div class="t_btn">
                    <div class="t_sure t_cancel" @click="isPayOk=false">否</div>
                    <div class="t_sure" @click="sureOk">是</div>
                </div>
            </div>
        </section>
        <div class="title">
            <div class="backCss">
                <img src="../src/assets/images/back.png" class="back" @click="closeView"/>
            </div>
            解锁更多功能
        </div>
        <component :is="webView" ref="viewContainer" @payOk="payOk"></component>
    </div>
</template>

<script>
    import findeCom from './components/finde'
    import { resizePatch } from './assets/js/patchers'

    export default {
        data() {
            return {
                isPayOk:false
            }
        },
        created() {
        },
        components: {
            findeCom
        },
        computed: {
            webView() {
                return 'findeCom';
            }
        },
        mounted() {
            this.$Base.overScroll('.scroll');
            const container = this.$refs.appContainer;
            const viewContainer = this.$refs.viewContainer;
            const game = viewContainer.$refs.game;
            const updateZoom = this.$Base.updateZoom.bind(this.$Base);

            resizePatch(container, game, updateZoom);
        },
        methods: {
            sureOk(){
                this.isPayOk=false
                this.$refs.viewContainer.getStatus();
            },
            payOk(){
                this.isPayOk=true
            },
            closeView() { //关闭窗口
                if(!window.webkit){
                    return
                }
                window.webkit.messageHandlers.closeWebVC.postMessage({});
            },
        },
    }
</script>
